/*******************************************************************************
SET MIN GRID WIDTH
When tabs have variable width content our CSS Grid styles are unable to adjust in
a way that makes the page look nice. The layout we want is essentially impossible
to pull off with dynamic, unknown content so this javascript is necessary to make
the necessary layout adjustments.
*******************************************************************************/

export default function setMinGridWidth(settings) {
    const { containers, items, padding, auto = 'fit' } = settings;

    // Loop through all the containers
    $(containers).each((index, set) => {
        const $set = $(set);

        // Reset this to start (necessary for handling window resizes correctly)
        $set.css('grid-template-columns', '');

        // Flip on CSS Grid
        $set.css('display', 'grid');

        // Get all the item widths
        const itemWidths = Array.from($set.find(items).map((i, item) => $(item).width()));

        // Find the maximum item content width (and allow for 10px of padding on each side)
        const maxItemWidth = Math.round(Math.max(...itemWidths)) + Number(padding);

        const gridFormat = auto === 'fit' ? 'auto-fit' : 'auto-fill';

        // Use the width of the widest item as a minimum for the tab width
        $set.css('grid-template-columns', `repeat(${gridFormat}, minmax(${maxItemWidth}px, 1fr))`);

        // The CSS has a max-height because the best way to let the items expand to their natural height
        // is by letting them flow into a single column. We set the max-height to avoid a content
        // jump/jitter after the page loads
        $set.css('max-height', 'none');

        // Special logic for specific toggle tabs sets (ones that are part of a group of filters)
        if (items === '.toggle-tab') {
            const numItems = $set.find(items).length;
            const maxWidth = (maxItemWidth + 16) * numItems;
            $(set).parents('.toggle-tabs-set.is-in-group').css('max-width', maxWidth);
        }

    });
}
